import Vue from 'vue'
import WarehouseTransformer
from '../../../transformers/catalog/warehouse/warehouse'

export default (payload) => {
  const transformedData = WarehouseTransformer.modify(payload)
  const id = transformedData.id
  return Vue.$http.put(`iwarehouse/${id}/highways/`, transformedData)
    .then(({ data }) => {
      let transformedResponse = WarehouseTransformer.fetch(data)
      return transformedResponse
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/updateiWarehouse.js